const audioPlayers = document.querySelectorAll('[data-audio-player]')

Array.prototype.forEach.call(audioPlayers, audioPlayer => {
  const id = audioPlayer.getAttribute('data-audio-player')
  const buttonWrapper = document.querySelector(`[data-audio-player-button="${id}"]`)
  const button = buttonWrapper.querySelector('.audio-player__button')
  const progressCircle = buttonWrapper.querySelector('.audio-player__progress-ring-circle')

  const progressRadius = progressCircle.r.baseVal.value
  const progressCircumference = progressRadius * 2 * Math.PI

  progressCircle.style.strokeDasharray = `${progressCircumference} ${progressCircumference}`
  progressCircle.style.strokeDashoffset = progressCircumference

  button.setAttribute('aria-pressed', 'false')
  button.addEventListener('click', event => {
    if(audioPlayer.readyState === 0) {
      audioPlayer.load()
    }

    if(audioPlayer.paused) {
      audioPlayer.play()
      button.classList.add('is-playing')
      button.setAttribute('aria-pressed', 'true')
    } else {
      audioPlayer.pause()
      button.classList.remove('is-playing')
      button.setAttribute('aria-pressed', 'false')
    }
  })

  audioPlayer.addEventListener('loadstart', event => {
    button.classList.add('is-loading')
  })

  audioPlayer.addEventListener('canplaythrough', event => {
    button.classList.remove('is-loading')
  })

  audioPlayer.addEventListener('timeupdate', event => {
    const progress = audioPlayer.currentTime / audioPlayer.duration * 100
    setProgress(progressCircle, progress, progressCircumference)
  })

  audioPlayer.addEventListener('ended', event => {
    button.classList.remove('is-playing')
    button.setAttribute('aria-pressed', 'false')
  })
})

function setProgress(circle, percent, circumference) {
  const offset = circumference - percent / 100 * circumference
  circle.style.strokeDashoffset = offset
}
